import React, { FC, useRef } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import useToggle from 'hooks/useToggle'
import IconButton from 'components/Luxkit/Button/IconButton'
import Dropdown from 'components/Luxkit/Dropdown'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import LineEllipsisVIcon from 'components/Luxkit/Icons/line/LineEllipsisVIcon'
import ListItem from 'components/Luxkit/List/ListItem'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryDown, mediaQueryUp } from 'components/utils/breakpoint'
import LineBarsIcon from 'components/Luxkit/Icons/line/LineBarsIcon'
import LineCommentExclamationIcon from 'components/Luxkit/Icons/line/LineCommentExclamationIcon'

const HeaderContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 10fr 1fr;
  grid-template-areas:
    "history header menu";
  height: ${rem(60)};
  padding: 0 ${rem(24)};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.five};

  ${mediaQueryUp.sm} {
    grid-template-columns: 0fr 10fr 1fr;
  }

  ${mediaQueryDown.xs} {
    padding: 0;
  }
`

const StyledHistory = styled.div`
  grid-area: history;
  display: block;

  ${mediaQueryUp.sm} {
    display: none;
  }
`

const StyledHeader = styled.div`
  grid-area: header;
  display: grid;
  align-content: center;
  margin-left: ${rem(8)};
`

const StyledMenu = styled.div`
  grid-area: menu;
  display: grid;
  justify-content: right;
  position: relative;
`

interface HeaderProps {
  toggleHistory?: () => void;
  toggleFeedback?: () => void;
  disableReportFeedback?: boolean;
}

const Header: FC<HeaderProps> = ({
  toggleHistory,
  toggleFeedback,
  disableReportFeedback,
}) => {
  const { value: open, toggle, off } = useToggle()
  const triggerRef = useRef<HTMLButtonElement>(null)

  return (
    <HeaderContainer>
      <StyledHistory>
        <IconButton
          kind="tertiary"
          variant="dark"
          size="large"
          shape="circle"
          data-testid="action-menu-button"
          aria-label="show history"
          onClick={toggleHistory}
        >
          <LineBarsIcon />
        </IconButton>
      </StyledHistory>
      <StyledHeader>
        <Heading variant="heading5">
          Chat with LESA
        </Heading>
        <BodyText variant="small">
          Luxury Escapes Support Assistant
        </BodyText>
      </StyledHeader>
      <StyledMenu>
        <IconButton
          kind="tertiary"
          variant="dark"
          size="large"
          shape="circle"
          data-testid="action-menu-button"
          aria-label="chat action menu"
          onClick={toggle}
          ref={triggerRef}
        >
          <LineEllipsisVIcon />
        </IconButton>
        <Dropdown
          open={open}
          caretType="none"
          caretAlignment="none"
          alignment="right"
          triggerRef={triggerRef}
          onClose={off}
        >
          <DropdownContainer fit="dropdown-items">
            <ListItem
              disabled={disableReportFeedback}
              size="medium"
              startIcon={<LineCommentExclamationIcon />}
              title="Report a problem"
              onClick={toggleFeedback}
            />
          </DropdownContainer>
        </Dropdown>
      </StyledMenu>
    </HeaderContainer>
  )
}

export default Header
